export default "__VITE_ASSET__DACet7VZ__"